import Tag from './Tag';
import variants from './variants';

export default Tag;
export { variants };
